<template>
	<div class="home" v-if="isShow">
		<van-nav-bar
		  	title="绑定桌子">
		</van-nav-bar>
		<van-cell-group>
			<van-field required clearable v-model="tableId" label="桌子ID:" placeholder="请输入桌子ID"/>
		</van-cell-group>
		<van-tabbar>
 			<van-button style="height: 35px;margin: 10px 3%;line-height: 35px;width: 94%;background: #FFB20D;color:#000;" round @click="bindCode()">绑定</van-button>
		</van-tabbar>
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		tableId:'',
      		isShow:false,
      	}
    },
    mounted:function(){
    	this.getCode();
    },
    methods:{
		getCode(){
			this.$axios({
                method: 'get',
                url: this.$build+'/api/qrcode/'+this.$route.params.id+'/index',
            }).then(res => {
            	if(res.data.status==200){
            		console.log(res);
            		if(res.data.data.link){
            			window.location.replace(res.data.data.link);
            		}else{
            			this.isShow=true;
            		}
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('PackageDish.message'),
        		});
            });
		},
		bindCode(){
			if(this.tableId){
				this.$axios({
                method: 'PATCH',
                url: this.$build+'/api/qrcode/'+this.$route.params.id+'/update',
                data:{
                	id:this.tableId,
                }
            }).then(res => {
            		console.log(res)
            	if(res.data.status==200){
            		window.location.replace(res.data.data.link);
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('PackageDish.message'),
        		});
            });
			}else{
				this.$toast.fail('请输入桌子ID');
			}
		}
		
    }
}
</script>
<style scoped>
	.home{
		width: 100%;
		height: 100vh;
	}
	.menuList{
		width: 100%;
		height: 100px;
		margin-top: 20px;
		display: flex;
	}
	.menuItem{
		width: 50%;
		height: 100px;
		background: #fff;
		margin-left: 20px;
		border-radius: 3px;
		overflow: hidden;
	}
	.menuItem:nth-child(2){
		margin-right: 20px;
	}
	.menuTitle{
		width: 100%;
		height: 27px;
		line-height: 27px;
		font-size: 15px;
		text-align: center;
	}
	.menuIcon{
		width: 100%;
		height: 73px;
		line-height: 73px;
		background: #FFB20D;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/BC.vue